// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EqBehoiL60usTp4g {
  max-width: 1315px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.eDzJmS83yUM7I_b4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  margin-bottom: 20px;
}

.eDzJmS83yUM7I_b4 h2 {
  font-size: 30px;
  margin: 0;
}

.yOrAF2M9TbkqBHTG {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.t02RuAJHAtMPsWbz {
  width: 100%;
  max-width: 596px;
  padding: 24px 18px 24px 28px;
  border-radius: 16px;
  border: none;
  height: 58px;
  display: flex;
  align-items: center;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.v4zAuUpacQkXJ0u1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: #20336c;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  font-family: Roboto, sans-serif;
  border-radius: 4px;
  flex-shrink: 0;
}

.t02RuAJHAtMPsWbz .p-placeholder {
  color: #303030;
  padding: 0;
}

.t02RuAJHAtMPsWbz .p-dropdown-trigger {
  width: fit-content;
}

.DrRV5DwoMJoDrPEn {
  max-width: 360px;
  margin-left: 12px;
}

.ScMM79oFMI47oNfe {
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: start;
  margin-bottom: 10px;
}

.cxJAzKP0PWIo61sJ {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.NeprssEXbLAhxVc_ {
  display: flex;
  gap: 12px;
}

.Kyz5MQQLgqUJ_2E_,
.aXYOWP8LE6wiVNwN {
  padding: 10px 14px;
  font-size: 18px;
  font-weight: 300;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  color: #303030;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.Kyz5MQQLgqUJ_2E_ .p-button-icon-left,
.aXYOWP8LE6wiVNwN .p-button-icon-left {
  margin-right: 12px;
  font-size: 14px;
  color: #7b7b7b;
}

.Kyz5MQQLgqUJ_2E_:hover,
.aXYOWP8LE6wiVNwN:hover {
  background-color: #e1e7ed;
}

.bUqCUqK_sCQOYVgF {
  display: flex;
  align-items: center;
}

.YQZXWKkYsbUbr2ME {
  margin-right: 10px;
}

.Bgn0L4AEMEkf0RyZ {
  color: #000000;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.Bgn0L4AEMEkf0RyZ i {
  font-size: 16px;
  background-color: #4d87be;
  color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  margin-right: 12px;
}

.Bgn0L4AEMEkf0RyZ:hover i {
  background-color: #20336c;
}

.Bgn0L4AEMEkf0RyZ:hover .pBx1O2u1g83OmIl7 {
  text-decoration: underline;
}

.Bgn0L4AEMEkf0RyZ .pBx1O2u1g83OmIl7 {
  text-decoration: none;
}

.Rv38fSdk5c2MeUO3 {
  border-radius: 16px;
  background-color: #fff;
  padding: 16px 8px 16px 18px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.Rv38fSdk5c2MeUO3 .p-accordion {
  border: none;
  box-shadow: none;
}

.Rv38fSdk5c2MeUO3 .p-accordion .p-accordion-tab {
  border: none;
}

.Rv38fSdk5c2MeUO3 .p-accordion-header-link {
  background-color: #fff;
  border: none;
  padding: 0;
  margin-bottom: 20px;
}

.Rv38fSdk5c2MeUO3 .p-accordion-tab:last-child .p-accordion-header-link {
  margin-bottom: 0;
}

.Rv38fSdk5c2MeUO3 .p-accordion-content {
  background-color: #fff;
  border: none;
}

.oRsJzZQ1KMkQMA3Q {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.oRsJzZQ1KMkQMA3Q span {
  font-size: 20px;
  font-weight: 500;
}

.FaGo1SyRyc8w8OHa {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #6f6f6f;
}

.ycu1LDWik4VDuu7Z .p-orderlist-controls {
  display: none;
}

/*.orderListItem {*/
/*	margin: 0;*/
/*	padding: 0;*/
/*	height: 80px;*/
/*}*/

.g2ed92cNMFUNe4rT {
  margin: 0 30px 52px;
  width: calc(100% - 60px);
}

.g2ed92cNMFUNe4rT .p-dropdown {
  width: 100%;
  height: 66px;
  border-radius: 24px;
}

.g2ed92cNMFUNe4rT .p-dropdown-label {
  display: block;
  padding: 17px 32px 24px;
  font-size: 21px;
  font-family: "Roboto";
}

.JrwjgJX2c8MgsJ6H {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-items li {
  height: 88px;
  border-radius: 6px;
  margin: 4px 0px;
  padding: 4px;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.z9mX0yBXQVwuqqYg .p-orderlist-header {
  background-color: #f2e1bc;
  border-radius: 0 0 0 0;
  border: none;
}

.z9mX0yBXQVwuqqYg .p-orderlist-list {
  border-radius: 0 0 0 0;
  border: none;
  background-color: #faf9f8;
}

.z9mX0yBXQVwuqqYg .p-orderlist-item:hover {
  background-color: #f5f4f3;
}

.IZIJKEQ5ooE38He2 {
  height: 100%;
  font-size: 18px;
  font-weight: 400;
}

.QAkUSnOFbe4gGLJY,
.IZIJKEQ5ooE38He2 {
  display: flex;
  justify-content: space-between;
}

.QAkUSnOFbe4gGLJY > div,
.IZIJKEQ5ooE38He2 > div {
  /* width: 25%; */
  align-self: center;
  flex: 1;
  min-width: 0;
}

.QAkUSnOFbe4gGLJY > .IpM8k09LUIObbxHz,
.IZIJKEQ5ooE38He2 > .IpM8k09LUIObbxHz {
  /* width: 95px; */
  display: flex;
  flex: 0 0 95px;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.DI7llyzTVHApKbHu {
  position: absolute;
  color: #fff;
  width: 67px;
  height: 67px;
  display: none;
  border-radius: 6px;
}

.DI7llyzTVHApKbHu:hover {
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(0.893727px);
  display: flex;
}

.DI7llyzTVHApKbHu:hover::before {
  display: flex;
}

.DI7llyzTVHApKbHu::before {
  top: 37%;
  left: 37%;
  font-size: 18px;
  position: absolute;
  display: none;
}

.K4bg2eI5Ps_nb417 {
  width: 67px;
  height: 67px;
  overflow: hidden;
  border-radius: 6px;
}

.NZj70HNlZBozZQCG {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.Kyz5MQQLgqUJ_2E_ {
  margin-right: 5px;
}

.Nx9os3kIkdo7Kjbe {
  margin-bottom: 15px;
}

.BU2Dd3sNzkrxit8n {
  display: flex;
  align-items: center;
  gap: 20px;
}

.LQ9jxmHt4kE5IbFW {
  width: 114px;
  height: 67px;
}

.LQ9jxmHt4kE5IbFW:hover {
  background-color: #e1e7ed;
  border-radius: 6px;
}

.efrA6tVm0jcxhmAk {
  color: #818b93;
  width: 1.8rem;
}

.efrA6tVm0jcxhmAk span::before {
  font-size: 18px;
}

.efrA6tVm0jcxhmAk:hover {
  background-color: #dfdfdf;
}

.Su9HbssAiNB2K6pn {
  color: #c88900;
  height: 36px;
  width: 36px;
}

.Su9HbssAiNB2K6pn span::before {
  font-size: 18px;
}

.Su9HbssAiNB2K6pn:hover {
  background-color: #f2e1bc;
  color: #9a6a00;
}

.T5IW7Dnm9IphZnJt {
  color: #4d87be;
  width: 75px;
  height: 67px;
  border-radius: 6px;
}

.T5IW7Dnm9IphZnJt span::before {
  font-size: 18px;
}

.T5IW7Dnm9IphZnJt:hover {
  background-color: #e1e7ed;
  color: #20336c;
}

.l4e1U4fBAY2OtonJ {
  height: 36px;
  width: 36px;
  color: #dd0000;
}

.l4e1U4fBAY2OtonJ span::before {
  font-size: 18px;
}

.l4e1U4fBAY2OtonJ:hover {
  background-color: #ffcaca;
  color: #721010;
}

.kh_Uh3ZrksE6sDaz {
  display: flex;
  gap: 8px;
  margin-left: 10px;
}

.apYZCLUr6rwd1in9,
.WPuMLQAhJMdCcWwz {
  display: flex;
  align-items: center;
  gap: 2px;
}

.YDank_q8p2M2W7FT {
  background-color: transparent;
  border: none;
}

.YDank_q8p2M2W7FT:hover {
  background-color: #e1e7ed;
  border-radius: 6px;
}

.jwXN6S86nVghNM9L,
.YDank_q8p2M2W7FT {
  color: #4d87be;
  width: 75px;
  height: 67px;
  border-radius: 6px;
}

.jwXN6S86nVghNM9L:hover,
.YDank_q8p2M2W7FT:hover {
  background-color: #e1e7ed;
  color: #20336c;
}

.oZCnxg5ygQnaJsZk {
  color: #dd0000;
  width: 75px;
  height: 67px;
  border-radius: 6px;
}

.oZCnxg5ygQnaJsZk:hover {
  background-color: #ffcaca;
  color: #721010;
}

.y5iHpvdMhaA8QzMs {
  width: 624px !important;
  background-color: #f3f5f7;
  border-radius: 16px !important;
  max-height: 400px;
  padding-bottom: 30px;
  padding-right: 10px;
  margin-block: 15px;
}

.y5iHpvdMhaA8QzMs .p-dialog-content {
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.y5iHpvdMhaA8QzMs .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.pG1fG2WihMsrGsfh {
  width: 674px !important;
  height: fit-content;
  background-color: #f3f5f7;
  border-radius: 16px !important;
}

.pG1fG2WihMsrGsfh .p-dialog {
  border-radius: 16px !important;
}

.pG1fG2WihMsrGsfh .p-dialog-footer {
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.pG1fG2WihMsrGsfh .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa {
  width: 541px !important;
  height: 354px !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.By_14zkV4XUVNJKa .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.By_14zkV4XUVNJKa .RaqWt5qIR14DkLs6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.QSHyt7sOmMwSZ6Kf {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
}

.QSHyt7sOmMwSZ6Kf:hover {
  background-color: #185625;
}

.d8TTigY5xWktckql {
  background-color: #e1e7ed;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  width: 100%;
}

.d8TTigY5xWktckql .p-button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  padding: 15px 0px;
  flex: 1;
}

/* Close button in MultiSelect panel header */
.uFDyAsKn8LwujYaC {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #6c757d !important;
  padding: 0.5rem !important;
}

.uFDyAsKn8LwujYaC:hover {
  background: transparent !important;
}

.d8TTigY5xWktckql .p-highlight {
  background-color: #4d87be;
  border-radius: 16px;
}

.GP9lDg_JBC0Jtp6B {
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.GP9lDg_JBC0Jtp6B .p-dropdown-label {
  font-size: 18px;
  padding: 14px 20px;
}

.NBV7bgeoBgmliiyv {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.k2GbHgRW4rZk_JIs input {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

/* Desktop: ensure MultiSelect tokens wrap and panel can expand (match OrderPage) */
.YvMFatzABYepyaoQ .p-multiselect-items-wrapper {
  padding: 10px !important;
}

.YvMFatzABYepyaoQ .p-multiselect-label {
  display: flex;
  flex-wrap: wrap;
  row-gap: 5px;
}

.YvMFatzABYepyaoQ .p-multiselect-label {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset;
}

.YvMFatzABYepyaoQ .p-multiselect-panel {
  max-height: none !important;
  height: auto !important;
}

.Pj4y54h7Es0cW_J0 .p-multiselect {
  width: 100%;
  border-radius: 24px;
}

.Pj4y54h7Es0cW_J0 .p-multiselect-label {
  padding: 0;
  font-size: 16px;
}

.Pj4y54h7Es0cW_J0 .p-multiselect-token {
  background-color: #20336c15;
  border-radius: 100px;
}

.aqtEWWvRQtoudWLx {
  background-color: #ffffff;
  border: none !important;
  height: 100%;
  padding: 14px 16px 14px 20px;
  font-size: 18px;
  resize: none;
  box-shadow: none;
}

.cKdO462W2q4lkr6O {
  background-color: #ffffff;
  border-radius: 16px;
  padding-right: 4px;
  overflow: hidden;
  height: 91px;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
  border: 1px solid rgb(206, 212, 218);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}

.cKdO462W2q4lkr6O:hover {
  border-color: rgb(33, 150, 243);
}

.ChdGud6zDAU6RLY5:active {
  border-color: rgb(33, 150, 243);
}

.lqqhiUYbbL0eaHSe {
  width: 100%;
  background-color: #dd0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.lqqhiUYbbL0eaHSe:hover {
  background-color: #721010;
}

.RJyi_a8SMoa_MB_w {
  width: 100%;
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4d87be;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.RJyi_a8SMoa_MB_w:hover {
  color: #305375;
}

.SNjLIZnuEILBidDk {
  width: 604px;
  height: 530px;
  background-color: #f3f5f7;
  border-radius: 16px !important;
}

.SNjLIZnuEILBidDk .p-dialog-content {
  max-height: 300px !important;
  padding: 0 !important;
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog {
  border-radius: 16px !important;
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog-footer {
  padding: 1.5rem !important;
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.ip3D3mFOWKclJ7TD {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.v9cdw2UvuTcYOa0t {
  display: inline-block;
}

.SQBO1xc2tO8EWgJF {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.GkeIc9cHaMrjJczz {
  width: 250px;
  height: 250px;
  border-radius: 25px;
  overflow: hidden;
}

.GkeIc9cHaMrjJczz .CmxWy2ztikMeuGQt {
  height: 100%;
  width: 100%;
}

.SHjY2wLeVtMfzeAq {
  width: 100%;
}

.SHjY2wLeVtMfzeAq > span {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4d87be;
  border-radius: 16px;
  padding: 14px 0;
  font-size: 18px;
  font-weight: 600;
}

.SHjY2wLeVtMfzeAq > span:hover {
  background-color: #20336c;
}

.SHjY2wLeVtMfzeAq > span > span {
  width: fit-content;
  flex-grow: 0;
}

.pG1fG2WihMsrGsfh .p-dialog-title,
.By_14zkV4XUVNJKa .p-dialog-title,
.SNjLIZnuEILBidDk .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.pG1fG2WihMsrGsfh .p-dialog-content {
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog-content {
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-content {
  background-color: #f3f5f7;
}

.pG1fG2WihMsrGsfh .field label {
  font-size: 20px !important;
  font-weight: 400 !important;
}

.e7fzFJef582wNzou {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.NFn9akhDRXA15dAI {
  background: #ffffff;
  padding: 8px;
  border-radius: 8px;
  min-height: 63px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.AFJLDsDEJU4t4ONL {
  background-size: cover;
  min-width: 56px !important;
  min-height: 56px !important;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
}

.N0kaviNcQkcaVHnz {
  display: flex;
  flex-direction: row;
}

.N0kaviNcQkcaVHnz .mVytRCEAikVQWGzO {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.P3c52QVyrMo03tFK {
  max-width: 500px;
  font-weight: 500;
  color: #303030;
  font-size: 14px;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.tQgBQ6Ui33MGby9t {
  max-width: 300px;
  color: #888888;
  font-weight: 400;
  font-size: 12px;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden !important;
  text-overflow: ellipsis;
  display: block;
  cursor: pointer;
}

.ATJvkSeaxKU_JFsx {
  display: flex;
  gap: 12px;
}

.meyIPXyliMA2xdCy {
  color: #1976d2;
  background: none;
  border: none;
}

.iJZRbXbk4qAMbMam {
  color: #d32f2f;
  background: none;
  border: none;
  font-size: 20px;
}

.meyIPXyliMA2xdCy i::before,
.iJZRbXbk4qAMbMam i::before {
  font-size: 16px;
}

.pCT9a4sDYRAjhpln {
  color: #000000;
  background-color: transparent;
  border: none;
  padding: 0;
  width: 100%;
}

.pCT9a4sDYRAjhpln i {
  margin-left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #f2e1bc;
  padding: 6px;
  border-radius: 8px;
}

.QxuSuF17Z0zzwUFb {
  border-radius: 16px;
  font-size: 16px;
  padding: 14px;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.DUT7N41oiNInRPcK {
  max-height: 65px;
  width: 40%;
  padding: 14px;
}

.JcU9DwPJ4gIRSLTq {
  display: flex;
  gap: 12px;
  align-items: center;
}

.DUT7N41oiNInRPcK {
  border-radius: 16px !important;
}

.QxuSuF17Z0zzwUFb .p-multiselect-label {
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: unset !important;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .IZIJKEQ5ooE38He2 {
    font-size: 14px;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(2) {
    width: 180px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(3) {
    width: 100px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(4) {
    width: 80px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(5) {
    width: 200px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(6) {
    width: 80px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(7) {
    width: 120px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(2) {
    width: 180px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(3) {
    width: 100px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(4) {
    width: 80px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(5) {
    width: 200px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(6) {
    width: 80px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(7) {
    width: 120px !important;
  }

  .K4bg2eI5Ps_nb417 {
    width: 50px;
    height: 50px;
  }

  .jwXN6S86nVghNM9L,
  .oZCnxg5ygQnaJsZk {
    width: 50px;
    height: 50px;
  }

  .LQ9jxmHt4kE5IbFW {
    width: 50px;
    height: 50px;
  }

  .kh_Uh3ZrksE6sDaz {
    gap: 4px;
  }
}

@media screen and (min-width: 768px) and (max-width: 900px) {
  .IZIJKEQ5ooE38He2 > div:nth-child(2) {
    width: 150px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(3) {
    width: 80px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(4) {
    width: 70px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(5) {
    width: 160px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(6) {
    width: 70px !important;
  }

  .IZIJKEQ5ooE38He2 > div:nth-child(7) {
    width: 100px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(2) {
    width: 150px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(3) {
    width: 80px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(4) {
    width: 70px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(5) {
    width: 160px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(6) {
    width: 70px !important;
  }

  .QAkUSnOFbe4gGLJY > div:nth-child(7) {
    width: 100px !important;
  }

  .K4bg2eI5Ps_nb417 {
    width: 45px;
    height: 45px;
  }

  .jwXN6S86nVghNM9L,
  .oZCnxg5ygQnaJsZk {
    width: 45px;
    height: 45px;
  }

  .LQ9jxmHt4kE5IbFW {
    width: 45px;
    height: 45px;
  }

  .kh_Uh3ZrksE6sDaz {
    gap: 2px;
  }
}

@media screen and (max-width: 768px) {
  .By_14zkV4XUVNJKa,
  .y5iHpvdMhaA8QzMs {
    width: 350px !important;
  }

  .pG1fG2WihMsrGsfh {
    width: 90%;
  }

  .pG1fG2WihMsrGsfh .field label {
    font-size: 14px !important;
  }

  .SNjLIZnuEILBidDk .p-dialog-title,
  .By_14zkV4XUVNJKa .p-dialog-title,
  .pG1fG2WihMsrGsfh .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }

  .By_14zkV4XUVNJKa .RaqWt5qIR14DkLs6 {
    font-size: 16px;
  }

  .NBV7bgeoBgmliiyv {
    font-size: 16px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.03),
      0 0 2px rgba(0, 0, 0, 0.06),
      0 2px 6px rgba(0, 0, 0, 0.12);
  }

  .QSHyt7sOmMwSZ6Kf {
    padding: 14px 0;
    font-size: 16px;
  }

  .lqqhiUYbbL0eaHSe {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }

  .RJyi_a8SMoa_MB_w {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }

  .d8TTigY5xWktckql {
    background-color: #e1e7ed;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    width: 100%;
  }

  .d8TTigY5xWktckql .p-button {
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 0;
    flex: 1;
  }

  .d8TTigY5xWktckql .p-highlight {
    background-color: #4d87be;
    border-radius: 8px;
  }

  .SNjLIZnuEILBidDk {
    width: 350px;
  }

  .SNjLIZnuEILBidDk p {
    font-size: 14px;
    text-align: center;
  }

  .SHjY2wLeVtMfzeAq > span {
    font-size: 16px;
  }
}

@media screen and (max-width: 764px) {
  .oRsJzZQ1KMkQMA3Q span {
    font-size: 18px;
  }
}

@media screen and (max-width: 660px) {
  .oRsJzZQ1KMkQMA3Q span {
    font-size: 16px;
  }
}

@media screen and (max-width: 600px) {
  .eDzJmS83yUM7I_b4 {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 16px;
  }

  .eDzJmS83yUM7I_b4 h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .t02RuAJHAtMPsWbz {
    width: 100%;
    font-size: 14px !important;
    border-radius: 16px;
    padding: 0 14px;
    height: 44px;
    display: flex;
    align-items: center;
    border: none;
    box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  }

  .BU2Dd3sNzkrxit8n {
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .t02RuAJHAtMPsWbz .p-placeholder {
    font-size: 14px;
    color: #a4a4a4;
    padding: 0;
  }

  .t02RuAJHAtMPsWbz .p-dropdown-trigger {
    width: fit-content;
  }

  .ScMM79oFMI47oNfe {
    flex-direction: row-reverse;
    align-items: start;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .NeprssEXbLAhxVc_ {
    margin: 0;
    gap: 0;
  }

  .Bgn0L4AEMEkf0RyZ {
    padding: 0;
  }

  .Bgn0L4AEMEkf0RyZ span {
    display: none;
  }

  .Bgn0L4AEMEkf0RyZ i {
    font-size: 12px;
    width: 63px;
    height: 26px;
    border-radius: 6px;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Kyz5MQQLgqUJ_2E_,
  .aXYOWP8LE6wiVNwN {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 0;
    width: fit-content;
    height: 26px;
    border-radius: 6px;
    padding: 8px 14px;
    box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
    color: #303030;
  }

  .Kyz5MQQLgqUJ_2E_ .p-button-icon-left,
  .aXYOWP8LE6wiVNwN .p-button-icon-left {
    margin-right: 12px;
    color: #a4a4a4;
  }

  .Rv38fSdk5c2MeUO3 .p-accordion-content {
    padding: 5px;
  }

  /* Allow PrimeReact MultiSelect tokens to wrap and let the panel expand */
  .YvMFatzABYepyaoQ .p-multiselect-label {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }

  .YvMFatzABYepyaoQ .p-multiselect-label-container .p-multiselect-label {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset;
  }

  .YvMFatzABYepyaoQ .p-multiselect-token {
    max-width: none;
    /* white-space: normal; */
    display: inline-flex;
    align-items: center;
  }

  .YvMFatzABYepyaoQ .p-multiselect-token-label {
    /* white-space: normal; */
    overflow: visible;
  }

  /* Ensure the dropdown panel can grow to fit many items */
  .YvMFatzABYepyaoQ .p-multiselect-panel {
    max-height: none !important;
    height: auto !important;
  }

  /* Match OrderPage MultiSelect structure so tokens are visible and wrap */
  .Pj4y54h7Es0cW_J0 {
    margin-bottom: 24px;
  }

  .Pj4y54h7Es0cW_J0 .p-multiselect {
    width: 100%;
    border-radius: 16px;
  }

  .Pj4y54h7Es0cW_J0 .p-multiselect-label {
    padding: 14px 20px 14px;
    font-size: 18px;
  }

  .Pj4y54h7Es0cW_J0 .p-multiselect-token {
    background-color: #20336c15;
    border-radius: 100px;
  }

  .U3PtW52EyAbiai89 {
    border-radius: 16px;
    border: 1px solid #a4a4a4;
    overflow: hidden;
    padding: 12px 18px;
  }

  .YvMFatzABYepyaoQ {
    border-radius: 16px;
  }
}

.U3PtW52EyAbiai89 {
  border-radius: 16px;
  padding: 10px;
}

.BU2Dd3sNzkrxit8n {
  gap: 0;
  height: 36px;
}

.ATJvkSeaxKU_JFsx {
  gap: 1px;
}

@media screen and (max-width: 540px) {
  .tQgBQ6Ui33MGby9t {
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media screen and (max-width: 450px) {
  .P3c52QVyrMo03tFK {
    font-size: 12px;
  }
}

@media screen and (max-width: 374px) {
  .oRsJzZQ1KMkQMA3Q > div > span {
    font-size: 14px;
  }

  .NeprssEXbLAhxVc_ {
    gap: 1px;
  }

  .Kyz5MQQLgqUJ_2E_ > span:nth-child(2),
  .aXYOWP8LE6wiVNwN > span:nth-child(2) {
    display: none;
  }

  .Kyz5MQQLgqUJ_2E_ > span,
  .aXYOWP8LE6wiVNwN > span {
    margin: 0;
  }

  .Kyz5MQQLgqUJ_2E_,
  .aXYOWP8LE6wiVNwN {
    width: fit-content;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .T5IW7Dnm9IphZnJt,
  .l4e1U4fBAY2OtonJ {
    width: fit-content;
  }
}

@media screen and (max-width: 320px) {
  .oRsJzZQ1KMkQMA3Q > div > span {
    font-size: 12px;
  }

  .efrA6tVm0jcxhmAk {
    width: 1.6rem;
  }

  .BU2Dd3sNzkrxit8n {
    display: flex;
    flex-direction: row;
    gap: 1px;
  }

  .WPuMLQAhJMdCcWwz {
    margin-left: 0.8rem;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
}

.dGU0Ga8jBURQLFT0,
.KCEWD5EvDpwnoEMV {
  width: 320px !important;
}

.A7lvz3Cgh9Yeahtj,
.b0oh3P4U0okIrNRV,
.EP2XYm4cJ4twUkhH,
.nvDJrwsb5kt1Zbiw,
.yliz98Bw5Y45G91Y {
  max-width: 136px !important;
  text-align: center;
}

.kgLyvaLoTAZeYcH_,
.B39ZtSNq20geUY8g {
  max-width: 260px !important;
  text-align: center;
}

.KCEWD5EvDpwnoEMV {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.b0oh3P4U0okIrNRV {
  gap: 2px;
  display: flex;
  justify-content: center;
}

.gFjJwHCBKNwv3Aku,
.O3wyFyvapZ40DncQ,
.YBKVwaOfH24aZ4uN {
  max-width: 136px !important;
  display: flex;
  justify-content: center;
}

.B39ZtSNq20geUY8g {
  display: flex;
  justify-content: end;
}

@media screen and (min-width: 1300px) and (max-width: 1600px) {
  .dGU0Ga8jBURQLFT0,
  .KCEWD5EvDpwnoEMV {
    max-width: 300px !important;
  }

  .EP2XYm4cJ4twUkhH,
  .A7lvz3Cgh9Yeahtj,
  .nvDJrwsb5kt1Zbiw,
  .yliz98Bw5Y45G91Y,
  .YBKVwaOfH24aZ4uN,
  .b0oh3P4U0okIrNRV,
  .O3wyFyvapZ40DncQ,
  .gFjJwHCBKNwv3Aku {
    max-width: 80px !important;
  }

  .kgLyvaLoTAZeYcH_,
  .B39ZtSNq20geUY8g {
    max-width: 180px !important;
  }

  .QAkUSnOFbe4gGLJY > .IpM8k09LUIObbxHz,
  .IZIJKEQ5ooE38He2 > .IpM8k09LUIObbxHz {
    max-width: 40px;
  }
}

@media screen and (min-width: 1105px) and (max-width: 1300px) {
  .dGU0Ga8jBURQLFT0,
  .KCEWD5EvDpwnoEMV {
    max-width: 180px !important;
  }

  .EP2XYm4cJ4twUkhH,
  .YBKVwaOfH24aZ4uN {
    max-width: 70px;
  }

  .A7lvz3Cgh9Yeahtj,
  .nvDJrwsb5kt1Zbiw,
  .yliz98Bw5Y45G91Y,
  .b0oh3P4U0okIrNRV,
  .O3wyFyvapZ40DncQ,
  .gFjJwHCBKNwv3Aku {
    max-width: 50px !important;
  }

  .kgLyvaLoTAZeYcH_,
  .B39ZtSNq20geUY8g {
    max-width: 100px !important;
  }

  .QAkUSnOFbe4gGLJY > .IpM8k09LUIObbxHz,
  .IZIJKEQ5ooE38He2 > .IpM8k09LUIObbxHz {
    max-width: 40px;
  }

  .T5IW7Dnm9IphZnJt,
  .jwXN6S86nVghNM9L,
  .oZCnxg5ygQnaJsZk {
    max-width: 50px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1600px) {
  .IZIJKEQ5ooE38He2 {
    font-size: 16px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1105px) {
  .QAkUSnOFbe4gGLJY > .IpM8k09LUIObbxHz,
  .IZIJKEQ5ooE38He2 > .IpM8k09LUIObbxHz {
    max-width: 50px;
  }
}

@media screen and (max-width: 768px) {
  .tQgBQ6Ui33MGby9t {
    max-width: 150px;
  }

  .P3c52QVyrMo03tFK {
    max-width: 300px;
  }
}

@media screen and (max-width: 450px) {
  .tQgBQ6Ui33MGby9t {
    max-width: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/MenuItems.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd;;;iCAG+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB,cAAc;AACd,eAAe;AACf,iBAAiB;AACjB,IAAI;;AAEJ;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,OAAO;AACT;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA,mFAAmF;AACnF;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ;;;iCAG+B;EAC/B,oCAAoC;EACpC;;;;mBAIiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB;;;mCAG+B;EACjC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,OAAO;EACT;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gDAAgD;EAClD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,MAAM;EACR;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gDAAgD;IAChD,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA,yEAAyE;EACzE;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA,yDAAyD;EACzD;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA,yEAAyE;EACzE;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;;;EAKE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;EAGE,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;;EAEA;;;;;;;;IAQE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;;;;;IAME,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1315px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 14px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.pageHeader h2 {\r\n  font-size: 30px;\r\n  margin: 0;\r\n}\r\n\r\n.headerContentContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.dropdown {\r\n  width: 100%;\r\n  max-width: 596px;\r\n  padding: 24px 18px 24px 28px;\r\n  border-radius: 16px;\r\n  border: none;\r\n  height: 58px;\r\n  display: flex;\r\n  align-items: center;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.multiBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #20336c;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  font-family: Roboto, sans-serif;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dropdown :global(.p-placeholder) {\r\n  color: #303030;\r\n  padding: 0;\r\n}\r\n\r\n.dropdown :global(.p-dropdown-trigger) {\r\n  width: fit-content;\r\n}\r\n\r\n.subStationDropdown {\r\n  max-width: 360px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.groupActions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 28px;\r\n  align-items: start;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.menuItemsActionsWrapper {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.expandToggleWrapper {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.expandButton,\r\n.collapseButton {\r\n  padding: 10px 14px;\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  border-radius: 6px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  color: #303030;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.expandButton :global(.p-button-icon-left),\r\n.collapseButton :global(.p-button-icon-left) {\r\n  margin-right: 12px;\r\n  font-size: 14px;\r\n  color: #7b7b7b;\r\n}\r\n\r\n.expandButton:hover,\r\n.collapseButton:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.toggleWrapper {\r\n  margin-right: 10px;\r\n}\r\n\r\n.createGroupBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.createGroupBtn i {\r\n  font-size: 16px;\r\n  background-color: #4d87be;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.createGroupBtn:hover i {\r\n  background-color: #20336c;\r\n}\r\n\r\n.createGroupBtn:hover .createBtnText {\r\n  text-decoration: underline;\r\n}\r\n\r\n.createGroupBtn .createBtnText {\r\n  text-decoration: none;\r\n}\r\n\r\n.accordion {\r\n  border-radius: 16px;\r\n  background-color: #fff;\r\n  padding: 16px 8px 16px 18px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.accordion :global(.p-accordion) {\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.accordion :global(.p-accordion .p-accordion-tab) {\r\n  border: none;\r\n}\r\n\r\n.accordion :global(.p-accordion-header-link) {\r\n  background-color: #fff;\r\n  border: none;\r\n  padding: 0;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.accordion :global(.p-accordion-tab:last-child .p-accordion-header-link) {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.accordion :global(.p-accordion-content) {\r\n  background-color: #fff;\r\n  border: none;\r\n}\r\n\r\n.accordionHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.accordionHeader span {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.groupSubStationName {\r\n  font-size: 14px !important;\r\n  font-weight: 400 !important;\r\n  color: #6f6f6f;\r\n}\r\n\r\n.listWrapper :global(.p-orderlist-controls) {\r\n  display: none;\r\n}\r\n\r\n/*.orderListItem {*/\r\n/*\tmargin: 0;*/\r\n/*\tpadding: 0;*/\r\n/*\theight: 80px;*/\r\n/*}*/\r\n\r\n.dropDownWrapper {\r\n  margin: 0 30px 52px;\r\n  width: calc(100% - 60px);\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100%;\r\n  height: 66px;\r\n  border-radius: 24px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 17px 32px 24px;\r\n  font-size: 21px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 88px;\r\n  border-radius: 6px;\r\n  margin: 4px 0px;\r\n  padding: 4px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-header) {\r\n  background-color: #f2e1bc;\r\n  border-radius: 0 0 0 0;\r\n  border: none;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-list) {\r\n  border-radius: 0 0 0 0;\r\n  border: none;\r\n  background-color: #faf9f8;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-item:hover) {\r\n  background-color: #f5f4f3;\r\n}\r\n\r\n.stationOptionItem {\r\n  height: 100%;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n}\r\n\r\n.header,\r\n.stationOptionItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.header > div,\r\n.stationOptionItem > div {\r\n  /* width: 25%; */\r\n  align-self: center;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.header > .column1,\r\n.stationOptionItem > .column1 {\r\n  /* width: 95px; */\r\n  display: flex;\r\n  flex: 0 0 95px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n\r\n.imageEdit {\r\n  position: absolute;\r\n  color: #fff;\r\n  width: 67px;\r\n  height: 67px;\r\n  display: none;\r\n  border-radius: 6px;\r\n}\r\n\r\n.imageEdit:hover {\r\n  background: rgba(0, 0, 0, 0.35);\r\n  backdrop-filter: blur(0.893727px);\r\n  display: flex;\r\n}\r\n\r\n.imageEdit:hover::before {\r\n  display: flex;\r\n}\r\n\r\n.imageEdit::before {\r\n  top: 37%;\r\n  left: 37%;\r\n  font-size: 18px;\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n.optionImage {\r\n  width: 67px;\r\n  height: 67px;\r\n  overflow: hidden;\r\n  border-radius: 6px;\r\n}\r\n\r\n.optionNote {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.expandButton {\r\n  margin-right: 5px;\r\n}\r\n\r\n.isMultipleSelectButton {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.groupActionsWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n}\r\n\r\n.activeBtn:hover {\r\n  background-color: #e1e7ed;\r\n  border-radius: 6px;\r\n}\r\n\r\n.orderBtn {\r\n  color: #818b93;\r\n  width: 1.8rem;\r\n}\r\n\r\n.orderBtn span::before {\r\n  font-size: 18px;\r\n}\r\n\r\n.orderBtn:hover {\r\n  background-color: #dfdfdf;\r\n}\r\n\r\n.addOptionBtn {\r\n  color: #c88900;\r\n  height: 36px;\r\n  width: 36px;\r\n}\r\n\r\n.addOptionBtn span::before {\r\n  font-size: 18px;\r\n}\r\n\r\n.addOptionBtn:hover {\r\n  background-color: #f2e1bc;\r\n  color: #9a6a00;\r\n}\r\n\r\n.editGroupBtn {\r\n  color: #4d87be;\r\n  width: 75px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.editGroupBtn span::before {\r\n  font-size: 18px;\r\n}\r\n\r\n.editGroupBtn:hover {\r\n  background-color: #e1e7ed;\r\n  color: #20336c;\r\n}\r\n\r\n.deleteGroupBtn {\r\n  height: 36px;\r\n  width: 36px;\r\n  color: #dd0000;\r\n}\r\n\r\n.deleteGroupBtn span::before {\r\n  font-size: 18px;\r\n}\r\n\r\n.deleteGroupBtn:hover {\r\n  background-color: #ffcaca;\r\n  color: #721010;\r\n}\r\n\r\n.optionActionsWrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.orderBtnsWrapper,\r\n.actionsWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.noteBtn {\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.noteBtn:hover {\r\n  background-color: #e1e7ed;\r\n  border-radius: 6px;\r\n}\r\n\r\n.editOptionBtn,\r\n.noteBtn {\r\n  color: #4d87be;\r\n  width: 75px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.editOptionBtn:hover,\r\n.noteBtn:hover {\r\n  background-color: #e1e7ed;\r\n  color: #20336c;\r\n}\r\n\r\n.deleteOptionBtn {\r\n  color: #dd0000;\r\n  width: 75px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.deleteOptionBtn:hover {\r\n  background-color: #ffcaca;\r\n  color: #721010;\r\n}\r\n\r\n.noteModal {\r\n  width: 624px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n  max-height: 400px;\r\n  padding-bottom: 30px;\r\n  padding-right: 10px;\r\n  margin-block: 15px;\r\n}\r\n\r\n.noteModal :global(.p-dialog-content) {\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.noteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupModal {\r\n  width: 674px !important;\r\n  height: fit-content;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.groupModal :global(.p-dialog) {\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.groupModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.groupDeleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.selectButton {\r\n  background-color: #e1e7ed;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  padding: 15px 0px;\r\n  flex: 1;\r\n}\r\n\r\n/* Close button in MultiSelect panel header */\r\n.multiSelectHeaderClose {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  color: #6c757d !important;\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n.multiSelectHeaderClose:hover {\r\n  background: transparent !important;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n}\r\n\r\n.formDropdown {\r\n  border-radius: 16px;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.formDropdown :global(.p-dropdown-label) {\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.numberInput input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* Desktop: ensure MultiSelect tokens wrap and panel can expand (match OrderPage) */\r\n.multiSelect :global(.p-multiselect-items-wrapper) {\r\n  padding: 10px !important;\r\n}\r\n\r\n.multiSelect :global(.p-multiselect-label) {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  row-gap: 5px;\r\n}\r\n\r\n.multiSelect :global(.p-multiselect-label) {\r\n  white-space: normal !important;\r\n  overflow: visible !important;\r\n  text-overflow: unset;\r\n}\r\n\r\n.multiSelect :global(.p-multiselect-panel) {\r\n  max-height: none !important;\r\n  height: auto !important;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect) {\r\n  width: 100%;\r\n  border-radius: 24px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect-label) {\r\n  padding: 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.multiSelectWrapper :global(.p-multiselect-token) {\r\n  background-color: #20336c15;\r\n  border-radius: 100px;\r\n}\r\n\r\n.textarea {\r\n  background-color: #ffffff;\r\n  border: none !important;\r\n  height: 100%;\r\n  padding: 14px 16px 14px 20px;\r\n  font-size: 18px;\r\n  resize: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.textareaWrapper {\r\n  background-color: #ffffff;\r\n  border-radius: 16px;\r\n  padding-right: 4px;\r\n  overflow: hidden;\r\n  height: 91px;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n  border: 1px solid rgb(206, 212, 218);\r\n  transition:\r\n    background-color 0.2s,\r\n    color 0.2s,\r\n    border-color 0.2s,\r\n    box-shadow 0.2s;\r\n}\r\n\r\n.textareaWrapper:hover {\r\n  border-color: rgb(33, 150, 243);\r\n}\r\n\r\n.texareaWrapper:active {\r\n  border-color: rgb(33, 150, 243);\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #dd0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.imageModal {\r\n  width: 604px;\r\n  height: 530px;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-content) {\r\n  max-height: 300px !important;\r\n  padding: 0 !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog) {\r\n  border-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-footer) {\r\n  padding: 1.5rem !important;\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModalFooter {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: start;\r\n}\r\n\r\n.cardWrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.preview {\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.optionCard {\r\n  width: 250px;\r\n  height: 250px;\r\n  border-radius: 25px;\r\n  overflow: hidden;\r\n}\r\n\r\n.optionCard .image {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn {\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n  padding: 14px 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n  background-color: #20336c;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n  width: fit-content;\r\n  flex-grow: 0;\r\n}\r\n\r\n.groupModal :global(.p-dialog-title),\r\n.groupDeleteModal :global(.p-dialog-title),\r\n.imageModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n  white-space: normal;\r\n  overflow-wrap: break-word;\r\n  word-break: break-word;\r\n}\r\n\r\n.groupModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupModal :global(.field) label {\r\n  font-size: 20px !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  min-height: 63px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.cardImage {\r\n  background-size: cover;\r\n  min-width: 56px !important;\r\n  min-height: 56px !important;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.cardInfo .info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 8px;\r\n}\r\n\r\n.name {\r\n  max-width: 500px;\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n  white-space: normal;\r\n  overflow-wrap: break-word;\r\n  word-break: break-word;\r\n}\r\n\r\n.subfield {\r\n  max-width: 300px;\r\n  color: #888888;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  min-width: 0;\r\n  overflow: hidden !important;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n  cursor: pointer;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 16px;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n.createBtn i {\r\n  margin-left: 0;\r\n  width: 100%;\r\n  font-size: 14px;\r\n  background-color: #f2e1bc;\r\n  padding: 6px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.menuItemsMultiSelect {\r\n  border-radius: 16px;\r\n  font-size: 16px;\r\n  padding: 14px;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.optionGroupDropdown {\r\n  max-height: 65px;\r\n  width: 40%;\r\n  padding: 14px;\r\n}\r\n\r\n.showConditionWrapper {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.optionGroupDropdown {\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.menuItemsMultiSelect :global(.p-multiselect-label) {\r\n  white-space: normal !important;\r\n  overflow: hidden !important;\r\n  text-overflow: unset !important;\r\n}\r\n\r\n@media screen and (min-width: 768px) and (max-width: 1024px) {\r\n  .stationOptionItem {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(2) {\r\n    width: 180px !important;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(3) {\r\n    width: 100px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(4) {\r\n    width: 80px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(5) {\r\n    width: 200px !important;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(6) {\r\n    width: 80px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(7) {\r\n    width: 120px !important;\r\n  }\r\n\r\n  .header > div:nth-child(2) {\r\n    width: 180px !important;\r\n  }\r\n\r\n  .header > div:nth-child(3) {\r\n    width: 100px !important;\r\n  }\r\n\r\n  .header > div:nth-child(4) {\r\n    width: 80px !important;\r\n  }\r\n\r\n  .header > div:nth-child(5) {\r\n    width: 200px !important;\r\n  }\r\n\r\n  .header > div:nth-child(6) {\r\n    width: 80px !important;\r\n  }\r\n\r\n  .header > div:nth-child(7) {\r\n    width: 120px !important;\r\n  }\r\n\r\n  .optionImage {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .editOptionBtn,\r\n  .deleteOptionBtn {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .activeBtn {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .optionActionsWrapper {\r\n    gap: 4px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) and (max-width: 900px) {\r\n  .stationOptionItem > div:nth-child(2) {\r\n    width: 150px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(3) {\r\n    width: 80px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(4) {\r\n    width: 70px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(5) {\r\n    width: 160px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(6) {\r\n    width: 70px !important;\r\n  }\r\n\r\n  .stationOptionItem > div:nth-child(7) {\r\n    width: 100px !important;\r\n  }\r\n\r\n  .header > div:nth-child(2) {\r\n    width: 150px !important;\r\n  }\r\n\r\n  .header > div:nth-child(3) {\r\n    width: 80px !important;\r\n  }\r\n\r\n  .header > div:nth-child(4) {\r\n    width: 70px !important;\r\n  }\r\n\r\n  .header > div:nth-child(5) {\r\n    width: 160px !important;\r\n  }\r\n\r\n  .header > div:nth-child(6) {\r\n    width: 70px !important;\r\n  }\r\n\r\n  .header > div:nth-child(7) {\r\n    width: 100px !important;\r\n  }\r\n\r\n  .optionImage {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n\r\n  .editOptionBtn,\r\n  .deleteOptionBtn {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n\r\n  .activeBtn {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n\r\n  .optionActionsWrapper {\r\n    gap: 2px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .groupDeleteModal,\r\n  .noteModal {\r\n    width: 350px !important;\r\n  }\r\n\r\n  .groupModal {\r\n    width: 90%;\r\n  }\r\n\r\n  .groupModal :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .imageModal :global(.p-dialog-title),\r\n  .groupDeleteModal :global(.p-dialog-title),\r\n  .groupModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n\r\n  .groupDeleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .input {\r\n    font-size: 16px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow:\r\n      0 4px 10px rgba(0, 0, 0, 0.03),\r\n      0 0 2px rgba(0, 0, 0, 0.06),\r\n      0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n\r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .selectButton {\r\n    background-color: #e1e7ed;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    width: 100%;\r\n  }\r\n\r\n  .selectButton :global(.p-button) {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 15px 0;\r\n    flex: 1;\r\n  }\r\n\r\n  .selectButton :global(.p-highlight) {\r\n    background-color: #4d87be;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .imageModal {\r\n    width: 350px;\r\n  }\r\n\r\n  .imageModal p {\r\n    font-size: 14px;\r\n    text-align: center;\r\n  }\r\n\r\n  .uploadBtn > span {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 764px) {\r\n  .accordionHeader span {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 660px) {\r\n  .accordionHeader span {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .pageHeader {\r\n    flex-direction: column;\r\n    justify-content: start;\r\n    align-items: start;\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .pageHeader h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .dropdown {\r\n    width: 100%;\r\n    font-size: 14px !important;\r\n    border-radius: 16px;\r\n    padding: 0 14px;\r\n    height: 44px;\r\n    display: flex;\r\n    align-items: center;\r\n    border: none;\r\n    box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  }\r\n\r\n  .groupActionsWrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 2px;\r\n  }\r\n\r\n  .dropdown :global(.p-placeholder) {\r\n    font-size: 14px;\r\n    color: #a4a4a4;\r\n    padding: 0;\r\n  }\r\n\r\n  .dropdown :global(.p-dropdown-trigger) {\r\n    width: fit-content;\r\n  }\r\n\r\n  .groupActions {\r\n    flex-direction: row-reverse;\r\n    align-items: start;\r\n    justify-content: space-between;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .expandToggleWrapper {\r\n    margin: 0;\r\n    gap: 0;\r\n  }\r\n\r\n  .createGroupBtn {\r\n    padding: 0;\r\n  }\r\n\r\n  .createGroupBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .createGroupBtn i {\r\n    font-size: 12px;\r\n    width: 63px;\r\n    height: 26px;\r\n    border-radius: 6px;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .expandButton,\r\n  .collapseButton {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n    margin-bottom: 0;\r\n    width: fit-content;\r\n    height: 26px;\r\n    border-radius: 6px;\r\n    padding: 8px 14px;\r\n    box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n    color: #303030;\r\n  }\r\n\r\n  .expandButton :global(.p-button-icon-left),\r\n  .collapseButton :global(.p-button-icon-left) {\r\n    margin-right: 12px;\r\n    color: #a4a4a4;\r\n  }\r\n\r\n  .accordion :global(.p-accordion-content) {\r\n    padding: 5px;\r\n  }\r\n\r\n  /* Allow PrimeReact MultiSelect tokens to wrap and let the panel expand */\r\n  .multiSelect :global(.p-multiselect-label) {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 6px;\r\n    align-items: center;\r\n  }\r\n\r\n  .multiSelect :global(.p-multiselect-label-container .p-multiselect-label) {\r\n    white-space: normal !important;\r\n    overflow: visible !important;\r\n    text-overflow: unset;\r\n  }\r\n\r\n  .multiSelect :global(.p-multiselect-token) {\r\n    max-width: none;\r\n    /* white-space: normal; */\r\n    display: inline-flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .multiSelect :global(.p-multiselect-token-label) {\r\n    /* white-space: normal; */\r\n    overflow: visible;\r\n  }\r\n\r\n  /* Ensure the dropdown panel can grow to fit many items */\r\n  .multiSelect :global(.p-multiselect-panel) {\r\n    max-height: none !important;\r\n    height: auto !important;\r\n  }\r\n\r\n  /* Match OrderPage MultiSelect structure so tokens are visible and wrap */\r\n  .multiSelectWrapper {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect) {\r\n    width: 100%;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect-label) {\r\n    padding: 14px 20px 14px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .multiSelectWrapper :global(.p-multiselect-token) {\r\n    background-color: #20336c15;\r\n    border-radius: 100px;\r\n  }\r\n\r\n  .multiSelectPanel {\r\n    border-radius: 16px;\r\n    border: 1px solid #a4a4a4;\r\n    overflow: hidden;\r\n    padding: 12px 18px;\r\n  }\r\n\r\n  .multiSelect {\r\n    border-radius: 16px;\r\n  }\r\n}\r\n\r\n.multiSelectPanel {\r\n  border-radius: 16px;\r\n  padding: 10px;\r\n}\r\n\r\n.groupActionsWrapper {\r\n  gap: 0;\r\n  height: 36px;\r\n}\r\n\r\n.actions {\r\n  gap: 1px;\r\n}\r\n\r\n@media screen and (max-width: 540px) {\r\n  .subfield {\r\n    max-width: 110px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n  .name {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 374px) {\r\n  .accordionHeader > div > span {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .expandToggleWrapper {\r\n    gap: 1px;\r\n  }\r\n\r\n  .expandButton > span:nth-child(2),\r\n  .collapseButton > span:nth-child(2) {\r\n    display: none;\r\n  }\r\n\r\n  .expandButton > span,\r\n  .collapseButton > span {\r\n    margin: 0;\r\n  }\r\n\r\n  .expandButton,\r\n  .collapseButton {\r\n    width: fit-content;\r\n    align-items: center;\r\n    justify-content: center;\r\n    display: flex;\r\n  }\r\n\r\n  .editGroupBtn,\r\n  .deleteGroupBtn {\r\n    width: fit-content;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n  .accordionHeader > div > span {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .orderBtn {\r\n    width: 1.6rem;\r\n  }\r\n\r\n  .groupActionsWrapper {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 1px;\r\n  }\r\n\r\n  .actionsWrapper {\r\n    margin-left: 0.8rem;\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 8px;\r\n  }\r\n}\r\n\r\n.titleHeaderCell,\r\n.nameCell {\r\n  width: 320px !important;\r\n}\r\n\r\n.costHeaderCell,\r\n.costCell,\r\n.imageHeaderCell,\r\n.noteHeaderCell,\r\n.activeHeaderCell {\r\n  max-width: 136px !important;\r\n  text-align: center;\r\n}\r\n\r\n.actionsHeaderCell,\r\n.actionsCell {\r\n  max-width: 260px !important;\r\n  text-align: center;\r\n}\r\n\r\n.nameCell {\r\n  white-space: normal;\r\n  overflow-wrap: break-word;\r\n  word-break: break-word;\r\n}\r\n\r\n.costCell {\r\n  gap: 2px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.activeCell,\r\n.noteCell,\r\n.imageCell {\r\n  max-width: 136px !important;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.actionsCell {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n@media screen and (min-width: 1300px) and (max-width: 1600px) {\r\n  .titleHeaderCell,\r\n  .nameCell {\r\n    max-width: 300px !important;\r\n  }\r\n\r\n  .imageHeaderCell,\r\n  .costHeaderCell,\r\n  .noteHeaderCell,\r\n  .activeHeaderCell,\r\n  .imageCell,\r\n  .costCell,\r\n  .noteCell,\r\n  .activeCell {\r\n    max-width: 80px !important;\r\n  }\r\n\r\n  .actionsHeaderCell,\r\n  .actionsCell {\r\n    max-width: 180px !important;\r\n  }\r\n\r\n  .header > .column1,\r\n  .stationOptionItem > .column1 {\r\n    max-width: 40px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1105px) and (max-width: 1300px) {\r\n  .titleHeaderCell,\r\n  .nameCell {\r\n    max-width: 180px !important;\r\n  }\r\n\r\n  .imageHeaderCell,\r\n  .imageCell {\r\n    max-width: 70px;\r\n  }\r\n\r\n  .costHeaderCell,\r\n  .noteHeaderCell,\r\n  .activeHeaderCell,\r\n  .costCell,\r\n  .noteCell,\r\n  .activeCell {\r\n    max-width: 50px !important;\r\n  }\r\n\r\n  .actionsHeaderCell,\r\n  .actionsCell {\r\n    max-width: 100px !important;\r\n  }\r\n\r\n  .header > .column1,\r\n  .stationOptionItem > .column1 {\r\n    max-width: 40px;\r\n  }\r\n\r\n  .editGroupBtn,\r\n  .editOptionBtn,\r\n  .deleteOptionBtn {\r\n    max-width: 50px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) and (max-width: 1600px) {\r\n  .stationOptionItem {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) and (max-width: 1105px) {\r\n  .header > .column1,\r\n  .stationOptionItem > .column1 {\r\n    max-width: 50px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .subfield {\r\n    max-width: 150px;\r\n  }\r\n\r\n  .name {\r\n    max-width: 300px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n  .subfield {\r\n    max-width: 100px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `EqBehoiL60usTp4g`;
export var pageHeader = `eDzJmS83yUM7I_b4`;
export var headerContentContainer = `yOrAF2M9TbkqBHTG`;
export var dropdown = `t02RuAJHAtMPsWbz`;
export var multiBadge = `v4zAuUpacQkXJ0u1`;
export var subStationDropdown = `DrRV5DwoMJoDrPEn`;
export var groupActions = `ScMM79oFMI47oNfe`;
export var menuItemsActionsWrapper = `cxJAzKP0PWIo61sJ`;
export var expandToggleWrapper = `NeprssEXbLAhxVc_`;
export var expandButton = `Kyz5MQQLgqUJ_2E_`;
export var collapseButton = `aXYOWP8LE6wiVNwN`;
export var left = `bUqCUqK_sCQOYVgF`;
export var toggleWrapper = `YQZXWKkYsbUbr2ME`;
export var createGroupBtn = `Bgn0L4AEMEkf0RyZ`;
export var createBtnText = `pBx1O2u1g83OmIl7`;
export var accordion = `Rv38fSdk5c2MeUO3`;
export var accordionHeader = `oRsJzZQ1KMkQMA3Q`;
export var groupSubStationName = `FaGo1SyRyc8w8OHa`;
export var listWrapper = `ycu1LDWik4VDuu7Z`;
export var dropDownWrapper = `g2ed92cNMFUNe4rT`;
export var dropDownPanel = `JrwjgJX2c8MgsJ6H`;
export var orderListItem = `z9mX0yBXQVwuqqYg`;
export var stationOptionItem = `IZIJKEQ5ooE38He2`;
export var header = `QAkUSnOFbe4gGLJY`;
export var column1 = `IpM8k09LUIObbxHz`;
export var imageEdit = `DI7llyzTVHApKbHu`;
export var optionImage = `K4bg2eI5Ps_nb417`;
export var optionNote = `NZj70HNlZBozZQCG`;
export var isMultipleSelectButton = `Nx9os3kIkdo7Kjbe`;
export var groupActionsWrapper = `BU2Dd3sNzkrxit8n`;
export var activeBtn = `LQ9jxmHt4kE5IbFW`;
export var orderBtn = `efrA6tVm0jcxhmAk`;
export var addOptionBtn = `Su9HbssAiNB2K6pn`;
export var editGroupBtn = `T5IW7Dnm9IphZnJt`;
export var deleteGroupBtn = `l4e1U4fBAY2OtonJ`;
export var optionActionsWrapper = `kh_Uh3ZrksE6sDaz`;
export var orderBtnsWrapper = `apYZCLUr6rwd1in9`;
export var actionsWrapper = `WPuMLQAhJMdCcWwz`;
export var noteBtn = `YDank_q8p2M2W7FT`;
export var editOptionBtn = `jwXN6S86nVghNM9L`;
export var deleteOptionBtn = `oZCnxg5ygQnaJsZk`;
export var noteModal = `y5iHpvdMhaA8QzMs`;
export var groupModal = `pG1fG2WihMsrGsfh`;
export var groupDeleteModal = `By_14zkV4XUVNJKa`;
export var text = `RaqWt5qIR14DkLs6`;
export var saveBtn = `QSHyt7sOmMwSZ6Kf`;
export var selectButton = `d8TTigY5xWktckql`;
export var multiSelectHeaderClose = `uFDyAsKn8LwujYaC`;
export var formDropdown = `GP9lDg_JBC0Jtp6B`;
export var input = `NBV7bgeoBgmliiyv`;
export var numberInput = `k2GbHgRW4rZk_JIs`;
export var multiSelect = `YvMFatzABYepyaoQ`;
export var multiSelectWrapper = `Pj4y54h7Es0cW_J0`;
export var textarea = `aqtEWWvRQtoudWLx`;
export var textareaWrapper = `cKdO462W2q4lkr6O`;
export var texareaWrapper = `ChdGud6zDAU6RLY5`;
export var deleteDialogBtn = `lqqhiUYbbL0eaHSe`;
export var cancelDialogBtn = `RJyi_a8SMoa_MB_w`;
export var imageModal = `SNjLIZnuEILBidDk`;
export var imageModalFooter = `ip3D3mFOWKclJ7TD`;
export var cardWrapper = `v9cdw2UvuTcYOa0t`;
export var preview = `SQBO1xc2tO8EWgJF`;
export var optionCard = `GkeIc9cHaMrjJczz`;
export var image = `CmxWy2ztikMeuGQt`;
export var uploadBtn = `SHjY2wLeVtMfzeAq`;
export var cardList = `e7fzFJef582wNzou`;
export var cardItem = `NFn9akhDRXA15dAI`;
export var cardImage = `AFJLDsDEJU4t4ONL`;
export var cardInfo = `N0kaviNcQkcaVHnz`;
export var info = `mVytRCEAikVQWGzO`;
export var name = `P3c52QVyrMo03tFK`;
export var subfield = `tQgBQ6Ui33MGby9t`;
export var actions = `ATJvkSeaxKU_JFsx`;
export var cardEditBtn = `meyIPXyliMA2xdCy`;
export var cardDeleteBtn = `iJZRbXbk4qAMbMam`;
export var createBtn = `pCT9a4sDYRAjhpln`;
export var menuItemsMultiSelect = `QxuSuF17Z0zzwUFb`;
export var optionGroupDropdown = `DUT7N41oiNInRPcK`;
export var showConditionWrapper = `JcU9DwPJ4gIRSLTq`;
export var multiSelectPanel = `U3PtW52EyAbiai89`;
export var titleHeaderCell = `dGU0Ga8jBURQLFT0`;
export var nameCell = `KCEWD5EvDpwnoEMV`;
export var costHeaderCell = `A7lvz3Cgh9Yeahtj`;
export var costCell = `b0oh3P4U0okIrNRV`;
export var imageHeaderCell = `EP2XYm4cJ4twUkhH`;
export var noteHeaderCell = `nvDJrwsb5kt1Zbiw`;
export var activeHeaderCell = `yliz98Bw5Y45G91Y`;
export var actionsHeaderCell = `kgLyvaLoTAZeYcH_`;
export var actionsCell = `B39ZtSNq20geUY8g`;
export var activeCell = `gFjJwHCBKNwv3Aku`;
export var noteCell = `O3wyFyvapZ40DncQ`;
export var imageCell = `YBKVwaOfH24aZ4uN`;
export default ___CSS_LOADER_EXPORT___;
